import React from 'react';
import { Hero } from '../components/sections/Hero';
import { About } from '../components/sections/About';
import { Focus } from '../components/sections/Focus';
import { WhyUs } from '../components/sections/WhyUs';
import { Trust } from '../components/sections/Trust';
import { Contact } from '../components/sections/Contact';
export function Home() {
  return <div className="flex flex-col w-full" data-id="element-208">
      <Hero data-id="element-209" />
      <About data-id="element-210" />
      <Focus data-id="element-211" />
      <WhyUs data-id="element-212" />
      <Trust data-id="element-213" />
      <Contact data-id="element-214" />
    </div>;
}